import { Theme } from '@mui/material';
import { mqFromDesktop } from '~/variables/breakpoints';
import theme from '~/theme';

const styles = {
  navbarWrapper: {
    display: 'flex',
    alignItems: 'start',
    flexDirection: 'column',
    gap: '5px',
    width: 'auto',
    zIndex: '4',
    padding: '10px 0px',
    margin: '0px 10px',
    borderTop: '1px solid #e0e0e0',
  },
  linkText: {
    zIndex: '4',
    padding: '3px 0px',
    textAlign: 'right',
    fontSize: '11px',
    textTransform: 'none',
    color: 'white',
    '&:hover': {
      color: 'lightBlue',
    },
  },
  managerClasses: (themeObj: Theme) => ({
    width: '100% !important',
    [themeObj.breakpoints?.up('md')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '5px',
    },
  }),
  markdown: {
    fontSize: '1em',
    maxHeight: '70vh',
    '@media screen and (min-height: 700px)': { maxHeight: '50vh' },
  },
  headerLinksSvg: {
    color: '#A7AAB6',
    width: '20px !important',
    height: '20px !important',
    marginLeft: '10px',
  },
  sessionsWrapper: {
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100% !important',
    padding: '0px',
  },
  activeSessions: {
    color: 'white',
  },
  activeSessionsWarn: {
    color: 'red',
  },
  sessionTableWrapper: {
    maxWidth: '700px',
    textAlign: 'center',
    margin: '25px auto',
  },
  whatsNewNotification: {
    textAlign: 'center',
  },
  clickHere: {
    cursor: 'pointer',
    color: 'black !important',
    '&:hover': {
      color: 'darkblue',
    },
  },

  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'start',
    height: '40px',
  },
  photo: {
    ...theme.defaultStyles?.boxShadow,
    padding: 0,
    transition: 'all 300ms linear',
    width: '50px',
    height: '50px',
    overflow: 'hidden',
    zIndex: '5',
    borderRadius: '50%',
  },
  avatarImg: {
    width: '32px',
    height: '32px',
    border: '0',
    borderRadius: '50%',
    flexShrink: 0,
  },
  collapse: {
    boxShadow: 'none',
    background: 'transparent',
    position: 'absolute',
    bottom: '100%',
    left: 0,
    right: 0,
    minWidth: '210px',
    marginBottom: '8px',
    transformOrigin: 'bottom',
    zIndex: 4000,
    [mqFromDesktop]: {
      left: '-10px',
      width: '100%',
    },
  },
  userItem: {
    margin: '2px 2px',
    padding: '0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    borderRadius: '6px',
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  dropdownListItem: {
    padding: '8px 16px',
    fontSize: '12px',
    color: theme.palette?.secondary.main,
    '&:hover': {
      backgroundColor: `rgba(255, 255, 255, 0.1)`,
    },
  },
  userLabel: {
    paddingLeft: '10px',
    fontSize: '12px',
    color: theme.palette?.secondary.main,
  },
  link: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '22px',
    width: '100%',
    display: 'block',
  },
  menuLink: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette?.primary.main,
    '&:hover': {
      color: theme.palette?.info.light,
    },
    '&:focus': {
      color: theme.palette?.info.light,
    },
  },
  dropdownLink: {
    color: theme.palette?.secondary.main,
    ':hover': {
      color: theme.palette?.secondary.main,
    },
    ':focus': {
      color: theme.palette?.secondary.main,
    },
  },
  rightIcon: {
    color: theme.palette?.secondary.main,
    width: '18px',
    height: '18px',
    marginLeft: '-10px',
    '&.open': {
      transform: 'rotate(180deg)',
    },
  },
  // primary menu items - higher visual prominence
  primaryMenuItem: {
    padding: '10px 16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    backgroundColor: 'transparent',
    width: '100%',
    textAlign: 'left',
    transition: 'background-color 0.15s ease',
    textDecoration: 'none',
    color: 'primary.main',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      color: 'primary.main',
    },
  },
  // secondary menu items - lower visual prominence
  secondaryMenuItem: {
    padding: '8px 16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    backgroundColor: 'transparent',
    width: '100%',
    textAlign: 'left',
    transition: 'background-color 0.15s ease',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
    },
  },
  // icon styling for primary actions
  menuIcon: {
    minWidth: '36px',
    color: 'text.primary',
  },
  // icon styling for secondary actions - de-emphasised
  secondaryMenuIcon: {
    minWidth: '36px',
    color: 'text.disabled',
  },
} as const;

export default styles;
